"use strict";
exports.__esModule = true;
exports.BalanceDateType = void 0;
var BalanceDateType;
(function (BalanceDateType) {
    BalanceDateType["Trade"] = "TRADE";
    BalanceDateType["Control"] = "CONTROL";
    BalanceDateType["Settlement"] = "SETTLEMENT";
})(BalanceDateType = exports.BalanceDateType || (exports.BalanceDateType = {}));
